import { useTranslation } from 'react-i18next';

export default function UpgradeBanner({ feature }) {
  const { t } = useTranslation();

  return (
    <div style={s.container}>
      <div style={s.icon}>&#128274;</div>
      <p style={s.message}>{t(`plan.featureLocked.${feature}`)}</p>
      <p style={s.hint}>{t('plan.upgradePrompt')}</p>
    </div>
  );
}

const s = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '2.5rem 1.5rem',
    borderRadius: 12,
    background: 'rgba(124, 58, 237, 0.08)',
    border: '1.5px dashed #7C3AED',
    textAlign: 'center',
  },
  icon: {
    fontSize: '2rem',
    marginBottom: '0.75rem',
  },
  message: {
    fontSize: '0.95rem',
    fontWeight: 600,
    color: '#F8FAFC',
    margin: '0 0 0.5rem 0',
  },
  hint: {
    fontSize: '0.82rem',
    color: '#94A3B8',
    margin: 0,
  },
};
